const local = '_POLICE_SESSION_'
var jwt_token = require('jwt-decode')

export default {
	getLang() {
		var lg = JSON.parse(localStorage.getItem('__POLICE_SESSION_LG_'))
		return lg['lg']
	},

	getDateFormat(minutos) {
		let _minutos = ''

		if (!_.isNil(minutos)) {
			_minutos = ' ' + minutos
		}

		var lg = JSON.parse(localStorage.getItem('__POLICE_SESSION_LG_'))
		return lg['dt'] + _minutos
	},

	getDecimal() {
		var lg = JSON.parse(localStorage.getItem('__POLICE_SESSION_LG_'))
		return lg['decimal']
	},

	setSessao(token, area) {
		// Pega a informacao
		var dados = jwt_token(token)

		var session = {
			token: token,
			nome: dados.nome,
			cpf: dados.cpf,
			login: dados.login,
			exp: dados.exp,
			cargo: dados.cargo,
			departamento: dados.departamento,
			email: dados.email,
			id_usuario: dados.id_usuario,
			telefone: dados.telefone,
			cienteNovosManuais: dados.ciente_novo_manual && dados.ciente_novo_manual === '1' ? true : false,
			dataCienteManuais: dados.data_ciente, 
			telefone2: dados.telefone2,
			msg: false,
			privilegios: dados.privis,
			area: area,
			foto: dados.foto,
			id_orgao: dados.id_orgao,
			trigrama: dados.trigrama,
			anac: dados.codigo_anac,
			desenvolvedor: dados.desenvolvedor == '0' ? false : true
		}

		var string = JSON.stringify(session)
		sessionStorage.setItem(local, string)
	},

	setFoto(foto) {
		if (sessionStorage.getItem(local) != null) {
			var sessao = JSON.parse(sessionStorage.getItem(local))
			sessao.foto = foto
			var string = JSON.stringify(sessao)
			sessionStorage.setItem(local, string)
		}
	},

	setCienteNovosManunais(ciente) {
		if (sessionStorage.getItem(local) != null) {
			var sessao = JSON.parse(sessionStorage.getItem(local))
			sessao.cienteNovosManuais = ciente
			var string = JSON.stringify(sessao)
			sessionStorage.setItem(local, string)
		}
	},

	setDataCienteNovosManuais(data) {
		if (sessionStorage.getItem(local) != null) {
			var sessao = JSON.parse(sessionStorage.getItem(local))
			sessao.dataCienteManuais = data
			var string = JSON.stringify(sessao)
			sessionStorage.setItem(local, string)
		}
	},

	setArea(area) {
		// Se exitir a sessão no local storage loga o usuário
		if (sessionStorage.getItem(local) != null) {
			var sessao = JSON.parse(sessionStorage.getItem(local))
			sessao.area = area
			var string = JSON.stringify(sessao)
			sessionStorage.setItem(local, string)
		}
	},

	getFoto() {
		// Se exitir a sessão no local storage loga o usuário
		if (sessionStorage.getItem(local) != null) {
			var sessao = JSON.parse(sessionStorage.getItem(local))
			return sessao.foto
		} else {
			return null
		}
	},

	getArea() {
		// Se exitir a sessão no local storage loga o usuário
		if (sessionStorage.getItem(local) != null) {
			var sessao = JSON.parse(sessionStorage.getItem(local))
			return sessao.area
		} else {
			return null
		}
	},

	getPrivilegio(idPrivilegio) {
		// verifica se tem sessao
		if (sessionStorage.getItem(local) != null) {
			var sessao = JSON.parse(sessionStorage.getItem(local))
			var tem = false

			// faz um for para achar o privilegio dentro da lista de privilégios
			for (var i = 0, len = sessao.privilegios.length; i < len; i++) {
				// se tiver
				if (sessao.privilegios[i] == idPrivilegio) {
					tem = true
					break
				}
			}

			return tem
		} else {
			return false
		}
	},

	setMsg(msg) {
		// Se exitir a sessão no local storage loga o usuário
		if (sessionStorage.getItem(local) != null) {
			var sessao = JSON.parse(sessionStorage.getItem(local))
			sessao.msg = msg
			var string = JSON.stringify(sessao)
			sessionStorage.setItem(local, string)
		}
	},

	logado() {
		// Se exitir a sessão no local storage loga o usuário
		if (sessionStorage.getItem(local) != null) {
			return true
		} else {
			return false
		}
	},

	remove() {
		sessionStorage.removeItem(local)
		//sessionStorage.removeItem('_POLICE_WS_')
	},

	getAllSessao() {
		// Se exitir a sessão no local storage loga o usuário
		if (sessionStorage.getItem(local) != null) {
			return JSON.parse(sessionStorage.getItem(local))
		} else {
			return null
		}
	},

	getToken() {
		// Se exitir a sessão no local storage loga o usuário
		if (sessionStorage.getItem(local) != null) {
			var sessao = JSON.parse(sessionStorage.getItem(local))
			return sessao.token
		} else {
			return null
		}
	},

	getNome() {
		// Se exitir a sessão no local storage loga o usuário
		if (sessionStorage.getItem(local) != null) {
			var sessao = JSON.parse(sessionStorage.getItem(local))
			return sessao.nome
		} else {
			return null
		}
	},

	getANAC() {
		// Se exitir a sessão no local storage loga o usuário
		if (sessionStorage.getItem(local) != null) {
			var sessao = JSON.parse(sessionStorage.getItem(local))
			return sessao.anac
		} else {
			return null
		}
	},

	getTrigrama() {
		// Se exitir a sessão no local storage loga o usuário
		if (sessionStorage.getItem(local) != null) {
			var sessao = JSON.parse(sessionStorage.getItem(local))
			return sessao.trigrama
		} else {
			return null
		}
	},

	getCienciaNovosManuais() { 
		if (sessionStorage.getItem(local) != null) {
			var sessao = JSON.parse(sessionStorage.getItem(local))
			return sessao.cienteNovosManuais
		} else {
			return null
		}
	},

	getDataCienciaNovosManuais() { 
		if (sessionStorage.getItem(local) != null) {
			var sessao = JSON.parse(sessionStorage.getItem(local))
			return sessao.dataCienteManuais
		} else {
			return null
		}
	},

	getDev() {
		// Se exitir a sessão no local storage loga o usuário
		if (sessionStorage.getItem(local) != null) {
			var sessao = JSON.parse(sessionStorage.getItem(local))
			return sessao.desenvolvedor
		} else {
			return null
		}
	},

	getIdOrgao() {
		// Se exitir a sessão no local storage loga o usuário
		if (sessionStorage.getItem(local) != null) {
			var sessao = JSON.parse(sessionStorage.getItem(local))
			return sessao.id_orgao
		} else {
			return null
		}
	},

	getLogin() {
		// Se exitir a sessão no local storage loga o usuário
		if (sessionStorage.getItem(local) != null) {
			var sessao = JSON.parse(sessionStorage.getItem(local))
			return sessao.login
		} else {
			return null
		}
	},

	getCargo() {
		// Se exitir a sessão no local storage loga o usuário
		if (sessionStorage.getItem(local) != null) {
			var sessao = JSON.parse(sessionStorage.getItem(local))
			return sessao.cargo
		} else {
			return null
		}
	},

	getDepartamento() {
		// Se exitir a sessão no local storage loga o usuário
		if (sessionStorage.getItem(local) != null) {
			var sessao = JSON.parse(sessionStorage.getItem(local))
			return sessao.departamento
		} else {
			return null
		}
	},

	getEmail() {
		// Se exitir a sessão no local storage loga o usuário
		if (sessionStorage.getItem(local) != null) {
			var sessao = JSON.parse(sessionStorage.getItem(local))
			return sessao.email
		} else {
			return null
		}
	},

	getId() {
		// Se exitir a sessão no local storage loga o usuário
		if (sessionStorage.getItem(local) != null) {
			var sessao = JSON.parse(sessionStorage.getItem(local))
			return sessao.id_usuario
		} else {
			return null
		}
	},

	getTelefone() {
		// Se exitir a sessão no local storage loga o usuário
		if (sessionStorage.getItem(local) != null) {
			var sessao = JSON.parse(sessionStorage.getItem(local))
			return sessao.telefone
		} else {
			return null
		}
	},

	getMsg() {
		// Se exitir a sessão no local storage loga o usuário
		if (sessionStorage.getItem(local) != null) {
			var sessao = JSON.parse(sessionStorage.getItem(local))
			return sessao.msg
		} else {
			return null
		}
	}
}